import script from "./ClaimMessagesPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ClaimMessagesPage.vue?vue&type=script&setup=true&lang=js"

import "./ClaimMessagesPage.vue?vue&type=style&index=0&id=3d7bad4c&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/claims-portal/claims-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d7bad4c"]])

export default __exports__